


























































































import {Component, Vue, Prop, PropSync, Watch, Emit} from 'vue-property-decorator';
import DxScrollView from 'devextreme-vue/scroll-view';
import {DxDropDownBox} from 'devextreme-vue/drop-down-box';
import {DxCheckBox} from 'devextreme-vue/check-box';
import {EcoFilialSelectionType, EcoNodeSelectionType} from '@/services/models-service';
import {numeralForm} from '@/utils/numbers';
import DButton from "@/components/DButton/button.vue";


@Component({
  name: 'TreeDropDownBox',
  components: {
    DButton,
    DxScrollView,
    DxDropDownBox,
    DxCheckBox,
  }
})
export default class extends Vue {
  @PropSync('selection') public selectionBlock: EcoFilialSelectionType[];
  @PropSync('selectAll', {default: false}) public checkAllFilials: boolean;
  @Prop() public title!: string;
  @Prop({default: false}) public disabled!: boolean;
  @Prop({default: false}) public showFacility!: boolean;
  @Prop({default: false}) public enableSelectAllCheckbox!: boolean;
  @Prop({default: false}) public oneActiveCheck!: boolean;

  // Массив идентификаторов всех выбранных ТУ
  private selectedNodes: number[] = [];
  // Массив идентификаторов всех выбранных объектов ТУ
  private selectedObjects: number[] = [];

  // Флаг, говорящий не реагировать на изменение выбранного филиала
  private selectionForbidMode = false;

  private selectAllCheckbox = false;
  private isDropDownOpen: boolean = false;

  private expandedFilials: { [id: number]: boolean } = {};
  private expandedNodes: { [key: string]: boolean } = {};

  private nodeKey(filialId: number, nodeId: number) {
    return filialId + ':' + nodeId;
  }

  isFilialExpanded(filialId: number) {
    return !!this.expandedFilials[filialId];
  }
  isNodeExpanded(filialId: number, nodeId: number) {
    return !!this.expandedNodes[this.nodeKey(filialId, nodeId)];
  }

  toggleFilial(filialId: number) {
    const next = !this.isFilialExpanded(filialId);
    this.$set(this.expandedFilials, filialId, next);
    this.saveState();
  }
  toggleNode(filialId: number, nodeId: number) {
    const k = this.nodeKey(filialId, nodeId);
    const next = !this.expandedNodes[k];
    this.$set(this.expandedNodes, k, next);
    this.saveState();
  }

   private readonly STORAGE_KEY = 'facility_save';

  mounted() {
    this.sortFacilitiesTree();
    this.loadState();
  }

  private saveState() {
    const state = {
      selectedNodes: this.selectedNodes,
      selectedObjects: this.selectedObjects,
      expandedFilials: this.expandedFilials,
      expandedNodes: this.expandedNodes,
      singleSelected: this.singleSelected,
      checkAllFilials: this.checkAllFilials
    };
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(state));
  }

  private loadState() {
    const saved = localStorage.getItem(this.STORAGE_KEY);
    if (saved) {
      try {
        const state = JSON.parse(saved);
        this.selectedNodes = state.selectedNodes || [];
        this.selectedObjects = state.selectedObjects || [];
        this.expandedFilials = state.expandedFilials || {};
        this.expandedNodes = state.expandedNodes || {};
        this.singleSelected = state.singleSelected || null;
        this.checkAllFilials = state.checkAllFilials || false;
      } catch (e) {
        console.warn('Failed to load saved state:', e);
      }
    }
  }

  private ensureExpandKeys() {
  (this.selectionBlock || []).forEach(f => {
    const shouldExpandFilial = f.nodes.some(n => n.check || (n.facilities || []).some(fc => fc.check));
    this.$set(this.expandedFilials, f.id, shouldExpandFilial);

    (f.nodes || []).forEach(n => {
      const k = this.nodeKey(f.id, n.id);
      const shouldExpandNode = n.check || (n.facilities || []).some(fc => fc.check);
      this.$set(this.expandedNodes, k, shouldExpandNode);
    });
  });
}

  private updateSelectAllCheckbox(value: boolean) {
    if (!this.enableSelectAllCheckbox || value === this.selectAllCheckbox) {
      return;
    }
    Vue.nextTick(() => {
      this.selectionForbidMode = true;
      this.selectAllCheckbox = value;
    })
  }

  private singleSelected: { type: any, filialId: any, nodeId: any, facilityId: any } | null;
  // Переменные, которые заполняются обработчиками (если их раньше не было)
  private selectedFilialId: null;
  private selectedNodeId: null;
  private selectedFacilityId: null;

  isNodeDisabled(filialId: any, nodeId: any) {
    if (!this.singleSelected) return false;
    if (this.singleSelected.type !== 'node') return true; // выбран facility -> узлы блокируем
    return !(this.singleSelected.filialId === filialId && this.singleSelected.nodeId === nodeId);
  }

  isFacilityDisabled(filialId: any, nodeId: any, facilityId: any) {
    if (!this.singleSelected) return false;
    if (this.singleSelected.type !== 'facility') return true; // выбран node -> объекты блокируем
    return !(
      this.singleSelected.filialId === filialId &&
      this.singleSelected.nodeId === nodeId &&
      this.singleSelected.facilityId === facilityId
    );
  }

  onNodeCheckChanged(filialId: any, node: any, e: any) {
    try {
      const next = !!(e && e.value);

      if (!next) {
        // Если снимаем, просто сбрасываем
        node.check = false;
        this.singleSelected = null;
        this.selectedNodeId = null;
        return;
      }

      // Ставим выбранный элемент
      node.check = true;
      this.singleSelected = {type: 'node', filialId, nodeId: node.id, facilityId: null};
      this.selectedFilialId = filialId;
      this.selectedNodeId = node.id;
      this.selectedFacilityId = null;

      // Сбрасываем все остальные, кроме текущего
      (this.selectionBlock || []).forEach(f => {
        (f.nodes || []).forEach(n => {
          if (n !== node) n.check = false;
          (n.facilities || []).forEach(fc => fc.check = false);
        });
      });

      // Закрываем выпадающий список после выбора
      Vue.nextTick(() => {
        this.isDropDownOpen = false;
      });

      } catch (error) {
        console.error("Ошибка в onNodeCheckChanged:", error);
      } finally {
      this.saveState(); // ← СОХРАНЕНИЕ ПОСЛЕ ИЗМЕНЕНИЯ
    }
  }

  onFacilityCheckChanged(filialId: any, node: any, facility: any, e: any) {
    try {
      const next = !!(e && e.value);

      if (!next) {
        facility.check = false;
        this.singleSelected = null;
        this.selectedFacilityId = null;
        return;
      }

      facility.check = true;
      this.singleSelected = {type: 'facility', filialId, nodeId: node.id, facilityId: facility.id};
      this.selectedFilialId = filialId;
      this.selectedNodeId = node.id;
      this.selectedFacilityId = facility.id;

      // Сбрасываем все остальные, кроме текущего
      (this.selectionBlock || []).forEach(f => {
        (f.nodes || []).forEach(n => {
          if (n !== node) n.check = false;
          (n.facilities || []).forEach(fc => {
            if (fc !== facility) fc.check = false;
          });
        });
      });

      // Закрываем выпадающий список после выбора
      Vue.nextTick(() => {
        this.isDropDownOpen = false;
      });

      } catch (error) {
        console.error("Ошибка в onFacilityCheckChanged:", error);
      } finally {
      this.saveState(); // ← СОХРАНЕНИЕ ПОСЛЕ ИЗМЕНЕНИЯ
    }
  }


  clearAllChecks() {
    // Снимаем все галочки по всему дереву
    (this.selectionBlock || []).forEach(f => {
      (f.nodes || []).forEach(n => {
        n.check = false;
        (n.facilities || []).forEach(fc => fc.check = false);
      });
    });
    this.saveState();
  }


  @Emit('selection-hierarchy-changed')
  private emitHierarchy(payload: {
    filials: number[];
    nodes: number[];
    facilities: number[];
  }): {
    filials: number[];
    nodes: number[];
    facilities: number[];
  } {
    return payload;
  }

  @Watch('selectionBlock', { deep: true })
  private onHierarchyChanged() {
    const filials = new Set<number>();
    const nodes = new Set<number>();
    const facilities = new Set<number>();

    const prevSelected = this.singleSelected ? { ...this.singleSelected } : null;

    this.selectionBlock.forEach(sb => {
      sb.nodes.forEach(n => {
        if (n.check) {
          nodes.add(n.id);
          filials.add(sb.id);
        }
        if (this.showFacility && Array.isArray(n.facilities)) {
          n.facilities.forEach(f => {
            if (f.check) {
              facilities.add(f.id);
              nodes.add(n.id);
              filials.add(sb.id);
            }
          });
        }
      });
    });
    if (prevSelected) {
      this.selectionBlock.forEach(sb => {
        if (sb.id !== prevSelected.filialId) return;

        sb.nodes.forEach(n => {
          if (n.id !== prevSelected.nodeId) return;

          if (prevSelected.type === 'node') {
            n.check = true;
          } else if (prevSelected.type === 'facility' && Array.isArray(n.facilities)) {
            n.facilities.forEach(f => {
              if (f.id === prevSelected.facilityId) f.check = true;
            });
          }
        });
      });
    }
    this.emitHierarchy({
      filials: Array.from(filials),
      nodes: Array.from(nodes),
      facilities: Array.from(facilities),
    });

    // this.isDropDownOpen = false;
  };

  get displayValue(): string[] | null {
    let filials: any[] = [];
    let isAllTreeSelected = true;
    for (const filial of this.selectionBlock) {
      filial.nodes.forEach((node: any) => {
        if (node.check && !this.showFacility) {
          filials.push(node.name);
        }
        node.facilities.forEach((f: any) => {
          if (f.check && this.showFacility) {
            filials.push(f.name);
          }
        })
      })
    }

    this.updateSelectAllCheckbox(isAllTreeSelected);
    return filials;
  }

  onSelectBoxChanged(e: any) {
    if (e && e.value === null) {
      this.clearAllChecks(); // снимем все галочки
      this.emitHierarchy({filials: [], nodes: [], facilities: []});
      this.isDropDownOpen = false;
    }
  }

  private facilityComparator(a: any, b: any) {
    const priorityOrder = [25, 29, 30]; // нужный порядок
    const rank = (obj: any) => {
      const id = Number(obj?.object_type_id);
      const idx = priorityOrder.indexOf(id);
      return idx === -1 ? priorityOrder.length : idx; // всё прочее — в конец
    };

    const ra = rank(a);
    const rb = rank(b);
    if (ra !== rb) return ra - rb;

    const an = (a?.name ?? '').toString();
    const bn = (b?.name ?? '').toString();
    return an.localeCompare(bn, 'ru', { sensitivity: 'base', numeric: true });
  }

  private sortFacilitiesTree() {
    (this.selectionBlock || []).forEach(f => {
      (f?.nodes || []).forEach((n: any) => {
        if (Array.isArray(n?.facilities)) {
          // сортируем на месте — Vue2 это «увидит»
          n.facilities.sort((x: any, y: any) => this.facilityComparator(x, y));
        }
      });
    });
  }

  @Watch('selectionBlock', { immediate: true })
  private onSelectionReplaced() {
    // небольшая защита на случай null/undefined
    if (!Array.isArray(this.selectionBlock)) return;
    this.sortFacilitiesTree();
    this.ensureExpandKeys();
  }
}
